import { ref, computed } from 'vue'

// Integration cards state - translations will be injected later
export const integrations = ref([
  {
    id: 1,
    name: 'Meta',
    icon: require('@/assets/icons/meta-logo.webp'),
    description: computed(() => ''),  // Will be set dynamically
    loading: false,
    disabled: true,
    disabledTooltip: computed(() => ''),  // Will be set dynamically
    connected: false,
  },
  {
    id: 3,
    name: 'X',
    icon: require('@/assets/icons/twitterx.svg'),
    description: computed(() => ''),  // Will be set dynamically
    loading: false,
    disabled: true,
    disabledTooltip: computed(() => ''),  // Will be set dynamically
    connected: false,
  },
  {
    id: 6,
    name: 'Google',
    icon: require('@/assets/icons/google.svg'),
    description: computed(() => ''),  // Will be set dynamically
    loading: false,
    disabled: false,
    disabledTooltip: computed(() => ''),  // Will be set dynamically
    connected: false,
  },
])

// Modal state
// showManageModal removed - no longer used
export const showGoogleStatusModal = ref(false)
// selectedIntegration removed - no longer used
export const isLoading = ref(true)
export const hasCheckedIntegration = ref(false)

// OAuth process state
export const oauthStatus = ref('connecting') // 'connecting', 'success', 'error'
export const showOAuthLoading = ref(false)
export const currentPlatformId = ref(null)
export const oauthErrorMessage = ref('')

// Computed
export const sortedIntegrations = computed(() => 
  integrations.value.sort((a, b) => a.id - b.id)
)
